import Link from "../../utils/Link";
import * as React from "react";

import useTranslations from "../../../hooks/useTranslations";
import { BuildingIcon } from "../../icons";
import Activity from "../ActivityPlate";
import { Text } from "@chakra-ui/react";
import { ActivityFragment, CampaignSummaryFragment, CompanyMinimalFragment } from '../../../graphql/generated/definitions';

type CampaignCreatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: CampaignSummaryFragment;
};

export function isCampaignCreatedActivity(
  q: ActivityFragment
): q is CampaignCreatedActivity {
  return q.key === "campaign.created";
}

interface CampaignCreatedActivityProps {
  activity: CampaignCreatedActivity;
}

export const CampaignCreatedActivity: React.FC<CampaignCreatedActivityProps> =
  ({ activity }) => {
    const t = useTranslations();

    return (
      <Activity
        activity={activity}
        id="campaignCreatedActivity"
        visual={<BuildingIcon className="w-10 h-10 text-accent-500" />}
      >
        <Text fontSize="sm">
          {t("activity.labels.campaignCreated", {
            campaign: (
              <Link to={`/campaigns/${activity.trackable.slug}`}>
                {activity.trackable.name}
              </Link>
            ),
          })}
        </Text>
      </Activity>
    );
  };
